/**
 * created by tian ruo jun
 default
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button} from "antd";

export default class Default extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            hideBtn: props.hideBtn
        }
    }

    show (){
        this.setState({hideBtn:false});
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            this.state.hideBtn ? "" :
            <Button
                type={"default"}
                onClick={this.props.onClick}
            >
                {this.props.icon}
                {this.props.btnName}
            </Button>
        )
    }

}